/* tslint:disable */
/* eslint-disable */
/**
 * Muze REST API
 * API Data backend for Muze
 *
 * The version of the OpenAPI document: 1.6.0
 * Contact: dash@muze.nyc
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    FFChat,
    FFChatFromJSON,
    FFChatToJSON,
    FFMember,
    FFMemberFromJSON,
    FFMemberToJSON,
    FFObject,
    FFObjectFromJSON,
    FFObjectToJSON,
    FFPublicChat,
    FFPublicChatFromJSON,
    FFPublicChatToJSON,
    FFSummary,
    FFSummaryFromJSON,
    FFSummaryToJSON,
    PaginatedFFChatList,
    PaginatedFFChatListFromJSON,
    PaginatedFFChatListToJSON,
    PaginatedFFMemberList,
    PaginatedFFMemberListFromJSON,
    PaginatedFFMemberListToJSON,
    PaginatedFFObjectList,
    PaginatedFFObjectListFromJSON,
    PaginatedFFObjectListToJSON,
    PaginatedFFSummaryList,
    PaginatedFFSummaryListFromJSON,
    PaginatedFFSummaryListToJSON,
    PatchedFFChat,
    PatchedFFChatFromJSON,
    PatchedFFChatToJSON,
    PatchedFFMember,
    PatchedFFMemberFromJSON,
    PatchedFFMemberToJSON,
    PatchedFFObject,
    PatchedFFObjectFromJSON,
    PatchedFFObjectToJSON,
} from '../models';

export interface FreeformChatsCreateRequest {
    fFChat: FFChat;
}

export interface FreeformChatsListRequest {
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface FreeformChatsPartialUpdateRequest {
    id: number;
    patchedFFChat?: PatchedFFChat;
}

export interface FreeformChatsRetrieveRequest {
    id: number;
}

export interface FreeformChatsUpdateRequest {
    id: number;
    fFChat: FFChat;
}

export interface FreeformMembersCreateRequest {
    fFMember: FFMember;
}

export interface FreeformMembersDestroyRequest {
    id: number;
}

export interface FreeformMembersListRequest {
    chat?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    user?: number;
}

export interface FreeformMembersOpenedUpdateRequest {
    id: number;
    fFMember: FFMember;
}

export interface FreeformMembersPartialUpdateRequest {
    id: number;
    patchedFFMember?: PatchedFFMember;
}

export interface FreeformMembersRetrieveRequest {
    id: number;
}

export interface FreeformMembersUpdateRequest {
    id: number;
    fFMember: FFMember;
}

export interface FreeformObjectsDestroyRequest {
    uuid: string;
}

export interface FreeformObjectsListRequest {
    chat?: number;
    created?: Date;
    creator?: number;
    maxY?: number;
    minY?: number;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface FreeformObjectsPartialUpdateRequest {
    uuid: string;
    patchedFFObject?: PatchedFFObject;
}

export interface FreeformObjectsRetrieveRequest {
    uuid: string;
}

export interface FreeformObjectsUpdateRequest {
    uuid: string;
    fFObject: FFObject;
}

export interface FreeformPreviewsListRequest {
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface FreeformPreviewsRetrieveRequest {
    id: number;
}

export interface FreeformPublicChatsRetrieveRequest {
    viewUrlKey: string;
}

/**
 * 
 */
export class FreeformApi extends runtime.BaseAPI {

    /**
     */
    async freeformChatsCreateRaw(requestParameters: FreeformChatsCreateRequest): Promise<runtime.ApiResponse<FFChat>> {
        if (requestParameters.fFChat === null || requestParameters.fFChat === undefined) {
            throw new runtime.RequiredError('fFChat','Required parameter requestParameters.fFChat was null or undefined when calling freeformChatsCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/chats/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FFChatToJSON(requestParameters.fFChat),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFChatFromJSON(jsonValue));
    }

    /**
     */
    async freeformChatsCreate(requestParameters: FreeformChatsCreateRequest): Promise<FFChat> {
        const response = await this.freeformChatsCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformChatsListRaw(requestParameters: FreeformChatsListRequest): Promise<runtime.ApiResponse<PaginatedFFChatList>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/chats/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedFFChatListFromJSON(jsonValue));
    }

    /**
     */
    async freeformChatsList(requestParameters: FreeformChatsListRequest): Promise<PaginatedFFChatList> {
        const response = await this.freeformChatsListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformChatsPartialUpdateRaw(requestParameters: FreeformChatsPartialUpdateRequest): Promise<runtime.ApiResponse<FFChat>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeformChatsPartialUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/chats/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedFFChatToJSON(requestParameters.patchedFFChat),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFChatFromJSON(jsonValue));
    }

    /**
     */
    async freeformChatsPartialUpdate(requestParameters: FreeformChatsPartialUpdateRequest): Promise<FFChat> {
        const response = await this.freeformChatsPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformChatsRetrieveRaw(requestParameters: FreeformChatsRetrieveRequest): Promise<runtime.ApiResponse<FFChat>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeformChatsRetrieve.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/chats/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFChatFromJSON(jsonValue));
    }

    /**
     */
    async freeformChatsRetrieve(requestParameters: FreeformChatsRetrieveRequest): Promise<FFChat> {
        const response = await this.freeformChatsRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformChatsUpdateRaw(requestParameters: FreeformChatsUpdateRequest): Promise<runtime.ApiResponse<FFChat>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeformChatsUpdate.');
        }

        if (requestParameters.fFChat === null || requestParameters.fFChat === undefined) {
            throw new runtime.RequiredError('fFChat','Required parameter requestParameters.fFChat was null or undefined when calling freeformChatsUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/chats/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FFChatToJSON(requestParameters.fFChat),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFChatFromJSON(jsonValue));
    }

    /**
     */
    async freeformChatsUpdate(requestParameters: FreeformChatsUpdateRequest): Promise<FFChat> {
        const response = await this.freeformChatsUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformMembersCreateRaw(requestParameters: FreeformMembersCreateRequest): Promise<runtime.ApiResponse<FFMember>> {
        if (requestParameters.fFMember === null || requestParameters.fFMember === undefined) {
            throw new runtime.RequiredError('fFMember','Required parameter requestParameters.fFMember was null or undefined when calling freeformMembersCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/members/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FFMemberToJSON(requestParameters.fFMember),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFMemberFromJSON(jsonValue));
    }

    /**
     */
    async freeformMembersCreate(requestParameters: FreeformMembersCreateRequest): Promise<FFMember> {
        const response = await this.freeformMembersCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformMembersDestroyRaw(requestParameters: FreeformMembersDestroyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeformMembersDestroy.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/members/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async freeformMembersDestroy(requestParameters: FreeformMembersDestroyRequest): Promise<void> {
        await this.freeformMembersDestroyRaw(requestParameters);
    }

    /**
     */
    async freeformMembersListRaw(requestParameters: FreeformMembersListRequest): Promise<runtime.ApiResponse<PaginatedFFMemberList>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.chat !== undefined) {
            queryParameters['chat'] = requestParameters.chat;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.user !== undefined) {
            queryParameters['user'] = requestParameters.user;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/members/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedFFMemberListFromJSON(jsonValue));
    }

    /**
     */
    async freeformMembersList(requestParameters: FreeformMembersListRequest): Promise<PaginatedFFMemberList> {
        const response = await this.freeformMembersListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformMembersOpenedUpdateRaw(requestParameters: FreeformMembersOpenedUpdateRequest): Promise<runtime.ApiResponse<FFMember>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeformMembersOpenedUpdate.');
        }

        if (requestParameters.fFMember === null || requestParameters.fFMember === undefined) {
            throw new runtime.RequiredError('fFMember','Required parameter requestParameters.fFMember was null or undefined when calling freeformMembersOpenedUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/members/{id}/opened/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FFMemberToJSON(requestParameters.fFMember),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFMemberFromJSON(jsonValue));
    }

    /**
     */
    async freeformMembersOpenedUpdate(requestParameters: FreeformMembersOpenedUpdateRequest): Promise<FFMember> {
        const response = await this.freeformMembersOpenedUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformMembersPartialUpdateRaw(requestParameters: FreeformMembersPartialUpdateRequest): Promise<runtime.ApiResponse<FFMember>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeformMembersPartialUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/members/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedFFMemberToJSON(requestParameters.patchedFFMember),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFMemberFromJSON(jsonValue));
    }

    /**
     */
    async freeformMembersPartialUpdate(requestParameters: FreeformMembersPartialUpdateRequest): Promise<FFMember> {
        const response = await this.freeformMembersPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformMembersRetrieveRaw(requestParameters: FreeformMembersRetrieveRequest): Promise<runtime.ApiResponse<FFMember>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeformMembersRetrieve.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/members/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFMemberFromJSON(jsonValue));
    }

    /**
     */
    async freeformMembersRetrieve(requestParameters: FreeformMembersRetrieveRequest): Promise<FFMember> {
        const response = await this.freeformMembersRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformMembersUpdateRaw(requestParameters: FreeformMembersUpdateRequest): Promise<runtime.ApiResponse<FFMember>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeformMembersUpdate.');
        }

        if (requestParameters.fFMember === null || requestParameters.fFMember === undefined) {
            throw new runtime.RequiredError('fFMember','Required parameter requestParameters.fFMember was null or undefined when calling freeformMembersUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/members/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FFMemberToJSON(requestParameters.fFMember),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFMemberFromJSON(jsonValue));
    }

    /**
     */
    async freeformMembersUpdate(requestParameters: FreeformMembersUpdateRequest): Promise<FFMember> {
        const response = await this.freeformMembersUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformObjectsDestroyRaw(requestParameters: FreeformObjectsDestroyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling freeformObjectsDestroy.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/objects/{uuid}/`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async freeformObjectsDestroy(requestParameters: FreeformObjectsDestroyRequest): Promise<void> {
        await this.freeformObjectsDestroyRaw(requestParameters);
    }

    /**
     */
    async freeformObjectsListRaw(requestParameters: FreeformObjectsListRequest): Promise<runtime.ApiResponse<PaginatedFFObjectList>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.chat !== undefined) {
            queryParameters['chat'] = requestParameters.chat;
        }

        if (requestParameters.created !== undefined) {
            queryParameters['created'] = (requestParameters.created as any).toISOString();
        }

        if (requestParameters.creator !== undefined) {
            queryParameters['creator'] = requestParameters.creator;
        }

        if (requestParameters.maxY !== undefined) {
            queryParameters['max_y'] = requestParameters.maxY;
        }

        if (requestParameters.minY !== undefined) {
            queryParameters['min_y'] = requestParameters.minY;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/objects/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedFFObjectListFromJSON(jsonValue));
    }

    /**
     */
    async freeformObjectsList(requestParameters: FreeformObjectsListRequest): Promise<PaginatedFFObjectList> {
        const response = await this.freeformObjectsListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformObjectsPartialUpdateRaw(requestParameters: FreeformObjectsPartialUpdateRequest): Promise<runtime.ApiResponse<FFObject>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling freeformObjectsPartialUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/objects/{uuid}/`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedFFObjectToJSON(requestParameters.patchedFFObject),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFObjectFromJSON(jsonValue));
    }

    /**
     */
    async freeformObjectsPartialUpdate(requestParameters: FreeformObjectsPartialUpdateRequest): Promise<FFObject> {
        const response = await this.freeformObjectsPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformObjectsRetrieveRaw(requestParameters: FreeformObjectsRetrieveRequest): Promise<runtime.ApiResponse<FFObject>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling freeformObjectsRetrieve.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/objects/{uuid}/`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFObjectFromJSON(jsonValue));
    }

    /**
     */
    async freeformObjectsRetrieve(requestParameters: FreeformObjectsRetrieveRequest): Promise<FFObject> {
        const response = await this.freeformObjectsRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformObjectsUpdateRaw(requestParameters: FreeformObjectsUpdateRequest): Promise<runtime.ApiResponse<FFObject>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling freeformObjectsUpdate.');
        }

        if (requestParameters.fFObject === null || requestParameters.fFObject === undefined) {
            throw new runtime.RequiredError('fFObject','Required parameter requestParameters.fFObject was null or undefined when calling freeformObjectsUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/objects/{uuid}/`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FFObjectToJSON(requestParameters.fFObject),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFObjectFromJSON(jsonValue));
    }

    /**
     */
    async freeformObjectsUpdate(requestParameters: FreeformObjectsUpdateRequest): Promise<FFObject> {
        const response = await this.freeformObjectsUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     * This view provides a cross section of data from all a users chats, the data on this endpoint is used primarily to compose the data on the Conversations View on the iOS app. Keep an eye out for optimizations.
     */
    async freeformPreviewsListRaw(requestParameters: FreeformPreviewsListRequest): Promise<runtime.ApiResponse<PaginatedFFSummaryList>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/previews/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedFFSummaryListFromJSON(jsonValue));
    }

    /**
     * This view provides a cross section of data from all a users chats, the data on this endpoint is used primarily to compose the data on the Conversations View on the iOS app. Keep an eye out for optimizations.
     */
    async freeformPreviewsList(requestParameters: FreeformPreviewsListRequest): Promise<PaginatedFFSummaryList> {
        const response = await this.freeformPreviewsListRaw(requestParameters);
        return await response.value();
    }

    /**
     * This view provides a cross section of data from all a users chats, the data on this endpoint is used primarily to compose the data on the Conversations View on the iOS app. Keep an eye out for optimizations.
     */
    async freeformPreviewsRetrieveRaw(requestParameters: FreeformPreviewsRetrieveRequest): Promise<runtime.ApiResponse<FFSummary>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling freeformPreviewsRetrieve.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/previews/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFSummaryFromJSON(jsonValue));
    }

    /**
     * This view provides a cross section of data from all a users chats, the data on this endpoint is used primarily to compose the data on the Conversations View on the iOS app. Keep an eye out for optimizations.
     */
    async freeformPreviewsRetrieve(requestParameters: FreeformPreviewsRetrieveRequest): Promise<FFSummary> {
        const response = await this.freeformPreviewsRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async freeformPublicChatsRetrieveRaw(requestParameters: FreeformPublicChatsRetrieveRequest): Promise<runtime.ApiResponse<FFPublicChat>> {
        if (requestParameters.viewUrlKey === null || requestParameters.viewUrlKey === undefined) {
            throw new runtime.RequiredError('viewUrlKey','Required parameter requestParameters.viewUrlKey was null or undefined when calling freeformPublicChatsRetrieve.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/freeform/public_chats/{view_url_key}/`.replace(`{${"view_url_key"}}`, encodeURIComponent(String(requestParameters.viewUrlKey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FFPublicChatFromJSON(jsonValue));
    }

    /**
     */
    async freeformPublicChatsRetrieve(requestParameters: FreeformPublicChatsRetrieveRequest): Promise<FFPublicChat> {
        const response = await this.freeformPublicChatsRetrieveRaw(requestParameters);
        return await response.value();
    }

}
